import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	Route,
	Redirect,
	useLocation,
	matchPath,
} from 'react-router-dom'
import { StoreValue } from 'store'

export const NoMatch: React.FunctionComponent = () => {
	const { i18n } = useTranslation()

	return <Redirect to={`/${i18n.language}`} />
}

interface PrivateRouteProps {
	component: React.FunctionComponent<any>
	path: string
	storeUserId?: string
	userOnBoardingFormVisited?: boolean
}

const PrivateRouteView: React.FunctionComponent<PrivateRouteProps> = ({
	component: Component,
	storeUserId,
	...rest
}) => {
	const { i18n } = useTranslation()
	const location = useLocation()
	const isChangeEmailUrl = matchPath(location.pathname, {
		path: `/:language(en|ro)/people/:personID/settings/update-email/:token`,
		exact: true,
		strict: false,
	})
	if (!storeUserId && isChangeEmailUrl?.isExact) {
		window.localStorage.setItem(
			'cv30_email_update_token',
			location.pathname,
		)
	}

	return (
		<Route
			{...rest}
			render={props =>
				storeUserId ? (
					<Component {...props} />
				) : (
					<Redirect to={`/${i18n.language}/auth`} />
				)
			}
		/>
	)
}

export const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = (
	props: PrivateRouteProps,
) => (
	<StoreValue keys={['user.id|storeUserId']}>
		<PrivateRouteView {...props} />
	</StoreValue>
)

const GuestRouteView: React.FunctionComponent<PrivateRouteProps> = ({
	component: Component,
	storeUserId,
	userOnBoardingFormVisited,
	...rest
}) => {
	const { i18n } = useTranslation()

	// set the route after log in
	let routeAfterLogIn: string = `/${i18n.language}`
	if (window.localStorage.getItem('cv30_email_update_token')) {
		routeAfterLogIn =
			window.localStorage.getItem('cv30_email_update_token') || ''
	} else if (!userOnBoardingFormVisited) {
		routeAfterLogIn = `/${i18n.language}/user-onboarding`
	} else if (sessionStorage.getItem('lastPageVisited')) {
		routeAfterLogIn = `${sessionStorage.getItem('lastPageVisited')}`
	}

	return (
		<Route
			{...rest}
			render={props =>
				!storeUserId ? (
					<Component {...props} />
				) : (
					<Redirect to={routeAfterLogIn} />
				)
			}
		/>
	)
}

export const GuestRoute: React.FunctionComponent<PrivateRouteProps> = (
	props: PrivateRouteProps,
) => (
	<StoreValue
		keys={[
			'user.profile.userOnBoardingFormVisited|userOnBoardingFormVisited',
			'user.id|storeUserId',
		]}
	>
		<GuestRouteView {...props} />
	</StoreValue>
)
